module.exports = __webpack_public_path__ + "static/documents/file.c8c8a6e.docx";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloads/file.docx
// module id = QpDV
// module chunks = 1